import { Router } from '@angular/router';

/**
 * Target for rendering the not-found page programmatically. Deliberately not a declared route: the
 * router's wildcard already renders that page for anything it cannot match. Nothing may claim this
 * as a real path — a param route that swallowed it would render itself instead of the 404, which is
 * why `:grade` is fenced by `gradeSlugGuard`.
 */
export const NOT_FOUND_URL = '/not-found';

/**
 * Renders the not-found page in place, for the dead ends the router cannot see: a URL that matches
 * a route but points at content that does not exist. `skipLocationChange` leaves the failed URL in
 * the address bar, so a reload reproduces the 404 and the link stays shareable instead of
 * collapsing into a meaningless /not-found.
 */
export function showNotFound(router: Router): void {
  void router.navigateByUrl(NOT_FOUND_URL, { skipLocationChange: true });
}
